import React from 'react';
import LazyImage from '../LazyImage';
import './Founder.css';
import founderImage from '../../assets/images/founder.webp';
import founderSmallImage from '../../assets/images/founder-sm.webp';

const Founder = () => {
    return (
        <section className="founder-section">
            <div className="founder-container">
                <div className="founder-content">
                    <div className="founder-left">
                        <div className="founder-tag">
                            Meet the Founder
                        </div>
                        <h2 className="founder-title">
                            Mandeep
                        </h2>
                        <h3 className="founder-subtitle">
                            Principal Consultant
                        </h3>
                        <div className="founder-description">
                            <p>
                                With over a decade of experience in accounting and financial 
                                consulting, Mandeep founded PFGS with a simple mission — to 
                                offer clients expert financial guidance with a personal touch. He 
                                believes in honest conversations, strategic thinking, and 
                                solutions that create lasting impact. His approach is built on 
                                trust, clarity, and partnership.
                            </p>
                        </div>
                        <div className="founder-quote">
                            "We take care of your finances, so you can focus on what 
                            matters most."
                        </div>
                    </div>
                    <div className="founder-right">
                        <div className="founder-image-container">
                            <LazyImage 
                                src={founderImage} 
                                smallSrc={founderSmallImage}
                                alt="Mandeep - Principal Consultant and Founder of PFGS" 
                                className="founder-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Founder;